exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3zk-2{font-size:13px}._32kz8{text-decoration:none;color:#000;z-index:10}._1I-mN,._32kz8{position:relative}._1I-mN{margin-right:4px}._1u9ng{-o-text-overflow:ellipsis;text-overflow:ellipsis}._32kz8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._32kz8:hover{color:#ffd906}", ""]);

// exports
exports.locals = {
	"agency": "_3zk-2",
	"agencyLink": "_32kz8",
	"agencyLogo": "_1I-mN",
	"agencyTitle": "_1u9ng"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AgencyInfoSmall/AgencyInfoSmall.css
// module id = 2431
// module chunks = 15 20